var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSquared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.2222C22 20.7567 20.7567 22 19.2222 22H4.77778C3.24389 22 2 20.7567 2 19.2222V4.77778C2 3.24333 3.24389 2 4.77778 2H19.2222C20.7567 2 22 3.24333 22 4.77778V19.2222Z",
    fill: "#3F51B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6577 12.72H15.8333V20H13.125V12.72H11.5V10.48H13.125V9.1304C13.1261 7.16592 13.9153 6 16.154 6H18V8.24H16.7612C15.8897 8.24 15.8333 8.576 15.8333 9.20488V10.48H18L17.6577 12.72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSquared);
export default __webpack_public_path__ + "static/media/facebook-squared.947386584fa17f058e816159823eb16c.svg";
export { ForwardRef as ReactComponent };